import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { PaymentV2Service } from '../../shared/services';
import { IPaymentSipConfig } from '../payment-sip/payment-sip.model';

@Component({
  selector: 'app-payment-sip-wallet',
  templateUrl: './payment-sip-wallet.component.html',
  styleUrls: ['./payment-sip-wallet.component.scss']
})
export class PaymentSipWalletComponent implements OnInit {

  @Input() config: IPaymentSipConfig;
  @Output() dataEmit = new EventEmitter();

  selectedWallet = { key: 'PAYTM', value: { name: 'PayTM Wallet', recurring: true } };

  constructor(
    private paymentV2: PaymentV2Service
  ) { }

  ngOnInit() {
    this.submitForm();
  }

  selectWallet(item) {
    this.selectedWallet = item;
  }

  submitForm() {
    this.paymentV2.pledgeBtn.subscribe(tab => {
      if (tab === 'wallet') {
        this.dataEmit.emit({
          'mode': this.config.selectedTab.order_mode,
          'mode_value': this.selectedWallet.key,
        });
      }
    });
  }

}
